
import React from 'react';
import DocImzala from './DocImzala';
import { useParams } from 'react-router-dom';

export default function DocImzalaPage() {
  const sabRef = localStorage.getItem('docimzala_sabRef') || '';
  const carRef = localStorage.getItem('docimzala_carRef') || '';
  const documentContent = localStorage.getItem('docimzala_content') || '';
  // Parametreler string olarak aktarılır
  return <DocImzala documentId={sabRef || ''} carRef={carRef || ''} documentContent={documentContent} />;
}
